import { createAction } from "@redux/actions/actionCreators";

const [useRevertVariantAssetField, revertVariantAssetField] = createAction<{
  productUuid: string;
  variantKey: string;
  productFieldId: string;
}>("product/revertVariantAssetField");

export default useRevertVariantAssetField;
export { revertVariantAssetField };
